var map = {
	"./AppointmentCalendarDashboard.vue": 43,
	"./Appointments.vue": 7059,
	"./BIDashboard.vue": 3128,
	"./Calendar.vue": 56,
	"./CallBack.vue": 7191,
	"./CashPayments.vue": 2644,
	"./Clients.vue": 4884,
	"./Complaints.vue": 9149,
	"./Contacts.vue": 4840,
	"./Customers.vue": 9208,
	"./Deals.vue": 2427,
	"./DuplicateContacts.vue": 3832,
	"./General.vue": 1396,
	"./Insights.vue": 1391,
	"./Leads.vue": 8484,
	"./Notifications.vue": 3089,
	"./Offers.vue": 8603,
	"./Opportunities.vue": 2947,
	"./OpportunityActivityReport.vue": 1025,
	"./PabauAppointments.vue": 2508,
	"./PabauSales.vue": 1381,
	"./PerformanceDashboard.vue": 7135,
	"./PhoneActivityReport.vue": 9146,
	"./PulseDashboard.vue": 2386,
	"./PurchaseInvoices.vue": 8638,
	"./Reports.vue": 2546,
	"./SupportTickets.vue": 1802,
	"./Treatments.vue": 1418,
	"./ViewContact.vue": 1857
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8796;